'use client';

import { cn } from '@ps/ui/utils';
import { Streamdown } from 'streamdown';

interface Props {
  content: string;
  className?: string;
}

/**
 * Render a markdown-encoded message body. Wraps `Streamdown` (the
 * repo's existing markdown renderer used by ai-elements) with the
 * same Tailwind utilities the Slate renderer uses, so a markdown
 * message and a slate-DOM message read the same once rendered.
 */
export function MarkdownMessageRenderer({ content, className }: Props) {
  return (
    <div
      className={cn(
        'space-y-1 break-words text-sm leading-snug',
        '[&_a]:text-brand-text [&_a]:hover:text-brand-hover [&_a]:underline',
        '[&_blockquote]:border-line-strong [&_blockquote]:text-content-2 [&_blockquote]:my-1 [&_blockquote]:border-l-2 [&_blockquote]:pl-3 [&_blockquote]:italic',
        '[&_ul]:my-1 [&_ul]:list-disc [&_ul]:pl-5',
        '[&_ol]:my-1 [&_ol]:list-decimal [&_ol]:pl-5',
        '[&_code]:bg-surface-2 [&_code]:rounded [&_code]:px-1 [&_code]:py-0.5 [&_code]:text-xs',
        '[&_pre]:bg-surface-1 [&_pre]:my-1 [&_pre]:overflow-x-auto [&_pre]:rounded [&_pre]:p-2 [&_pre]:text-xs',
        '[&_pre_code]:bg-transparent [&_pre_code]:p-0',
        className,
      )}
    >
      <Streamdown>{content}</Streamdown>
    </div>
  );
}
